module.exports = __webpack_public_path__ + "static/media/banner.e3a23821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.png
// module id = 2089
// module chunks = 7